import axios from 'axios';

export default {
    pre_insercion_lin_gen(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_infaprlineas.pre_insercion_lin_gen",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario,
				  })
			})
	},

	

	recuperar_lin_gen(p_email, p_usuario, p_poliza, p_ejecutivo, p_asistente, p_producto, p_corredor, p_estado){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infaprlineas.recuperar_lin_gen",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_poliza": p_poliza,  
				"p_ejecutivo": p_ejecutivo,
				"p_asistente": p_asistente, 
				"p_producto": p_producto,
				"p_corredor": p_corredor, 
				"p_estado": p_estado
				})
		})
	},

	consulta_poliza(p_email, p_ejecutivo, p_poliza){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infaprlineas.fnc_consultaPoliza",
			"p_args_in": JSON.stringify({
				"p_ejecutivo": p_ejecutivo,
				"p_poliza": p_poliza,
			  })
		})
	},

	consulta_corredor(p_email, p_corredor){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infaprlineas.fnc_consultarcorredor",
			"p_args_in": JSON.stringify({
				"p_codcorredor": p_corredor,
				})
		})
	},

}